import ContractsManager from './ContractsManager';

export default ContractsManager;
